import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { BlogProvider } from "../../context/BlogContext";
export const Blog = () => {
  return (
    <BlogProvider>
      <Overview />
    </BlogProvider>
  );
};

export const AddBlog = () => {
  return (
    <BlogProvider>
      
        <Add />
      
    </BlogProvider>
  );
};

export const EditBlog = () => {
  return (
    <BlogProvider>
      
        <Edit />
      
    </BlogProvider>
  );
};
